import { ReactNode } from 'react'
import styled, { css } from 'styled-components'

import Modal from '@/ui/Modal'
import Button from '@/ui/LegacyButton'
import { ButtonProps } from '@/ui/LegacyButton/types'
import Text from '@/ui/Text'

export type AlertType = 'success' | 'error' | 'warning' | 'info'

interface ModalWrapperProps {
  type: AlertType
  children?: ReactNode
  className: string
  onClose: () => void
}

interface ConfirmButtonProps extends Pick<ButtonProps, 'content' | 'onClick'> {
  type: AlertType
}

const colors = {
  success: '#00a86b',
  error: '#ff6f61',
  warning: '#fdda7e',
  info: '#0a5b8b',
}

export const ModalWrapper = styled(({ type, ...rest }: ModalWrapperProps) => (
  <Modal {...rest} />
))`
  ${({ type }: ModalWrapperProps) => css`
    &&& {
      width: 400px !important;

      .content {
        border-top: 38px solid ${colors[type]};
        text-align: center;
        padding: 2em !important;
        padding-top: 3em !important;
        min-height: 300px;
        display: flex;
        flex-direction: column;
      }

      .close.icon {
        top: 3px !important;
        right: 5px !important;

        :before {
          color: ${type === 'warning' ? 'initial' : '#fff'} !important;
        }
      }
    }
  `}
`

export const Message = styled(Text.Span).attrs({
  light: true,
})`
  display: block;
`

export const ConfirmButton = styled(({ type, ...rest }: ConfirmButtonProps) => (
  <Button {...rest} />
))`
  ${({ type }: ConfirmButtonProps) => css`
    &&&&:not(.green) {
      background: ${colors[type]} !important;
      border: 0;
      min-width: 100px;
      justify-content: center;

      &,
      :hover {
        color: ${type === 'warning' ? '#012d3e' : '#fff'} !important;
      }
    }
  `}
`
